<template>
  <div id="page-login">
    <div class="login__container">
      <div class="container__header"><h3>GESTAON ERP</h3></div>
      <div v-if="!showMasterChoice" class="container__body">
        <form v-show="loginMethod === 'emailAndPassword'" autocomplete="off">
          <div>
            <label>E-mail</label> <input style="display:none;" />
            <input
              type="email"
              class="input"
              placeholder="email@dominio.com.br"
              autocomplete="off"
              v-model="form.email"
            />
          </div>
          <div>
            <label>Senha</label> <input style="display:none;" />
            <input
              type="password"
              class="input"
              placeholder="*******"
              autocomplete="off"
              v-model="form.password"
            />
          </div>
          <div style="margin-top: 20px; margin-bottom: 5px;">
            <button class="btn" @click.prevent="login">entrar</button>
          </div>
          <div style="display: flex; justify-content: center;">
            <a
              href="javascript:void(0)"
              @click="$router.replace('/recovery-password')"
              style="font-size: .8em;"
              >esqueci minha senha</a
            >
          </div>
        </form>
        <div v-show="loginMethod === 'qrcode'" style="margin-bottom: 35px;">
          <div v-if="!errorOnLoadQRCode">
            <canvas id="qrcode"> </canvas>
          </div>
          <div
            v-else
            style="display: flex; align-items: center; justify-content: center;"
          >
            Não foi possível carregar o QR Code.
          </div>
        </div>

        <div class="body__action-buttons">
          <a
            href="javascript:void(0)"
            @click="loginMethod = 'qrcode'"
            v-if="loginMethod === 'emailAndPassword'"
            >logar com QR Code</a
          >
        </div>
        <div class="body__action-buttons">
          <a
            href="javascript:void(0)"
            @click="loginMethod = 'emailAndPassword'"
            v-if="loginMethod === 'qrcode'"
            >logar com email e senha</a
          >
        </div>
      </div>
      <div
        v-else
        class="container__body"
        style="display: flex; flex-direction: row; justify-content: space-around; align-items: center; width: 100%;"
      >
        <div style="margin-top: 20px; margin-bottom: 5px;">
          <button class="btn" @click.prevent="$router.replace('/dashboard')">
            Dashboard
          </button>
        </div>
        <div style="margin-top: 20px; margin-bottom: 5px;">
          <button class="btn" @click.prevent="openZepplinMasterLogin()">
            Painel Zepplin
          </button>
        </div>
      </div>
    </div>

    <app-modal
      v-if="showZepplinMasterLogin"
      @close="showZepplinMasterLogin = false"
      btnActionName="Salvar"
      @action="loginMasterUser()"
    >
      <template slot="header">
        <div style="margin-right: 20px; color: #C3C5C6;">
          AUTENTICAR USUÁRIO MASTER
        </div>
      </template>
      <template slot="body">
        <div>
          <div style="margin-bottom: 15px;">
            Email:
            <input
              type="email"
              class="input input-config"
              style="text-transform: none; border-bottom: 1px solid grey;"
              v-model="formMaster.email"
            />
          </div>
          <div>
            Senha:
            <input
              type="password"
              class="input input-config"
              style="text-transform: none; border-bottom: 1px solid grey;"
              v-model="formMaster.password"
            />
          </div>
        </div>
      </template>
    </app-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import QRCode from "qrcode";
import shortid from "shortid";
import ZepplinAuthAPI from "../../api/zepplin/auth";

export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      loginMethod: "emailAndPassword",
      qrcodeKey: null,
      errorOnLoadQRCode: null,
      showMasterChoice: false,
      showZepplinMasterLogin: false,
      formMaster: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapState("auth", ["isAuthenticated", "zepplinMasterToken"]),
  },
  methods: {
    ...mapActions("auth", [
      "authenticate",
      "authenticateByQRCode",
      "setZepplinMasterToken",
    ]),
    ...mapActions("toast", ["showToast", "showError"]),
    openZepplinMasterLogin() {
      this.showZepplinMasterLogin = true;
    },

    async loginMasterUser() {
      window.showAppLoading();
      window.setAppLoadingText("Tentando realizar o login...");
      try {
        const data = await ZepplinAuthAPI.authMasterUser(this.formMaster);
        this.setZepplinMasterToken(data.token);
        this.$router.replace("/master/company-request-monitoring");
      } catch (err) {
        window.removeAppLoading();
        this.showError("Não foi possível autenticar usuário master");
      }
    },

    async login() {
      const vm = this;
      window.showAppLoading();
      window.setAppLoadingText("Tentando realizar o login...");
      setTimeout(() => {
        vm.authenticate(vm.form)
          .then((res) => {
            const user = res.data.user;
            window.setAppLoadingText("Sucesso! Aguarde...");
            vm.$socket.close();
            vm.$socket.removeAllListeners();
            setTimeout(() => {
              if (vm.isAuthenticated) {
                if (user.isMaster) {
                  this.showMasterChoice = true;
                  window.removeAppLoading();
                } else vm.$router.replace("/");
              }
            }, 1000);
          })
          .catch((error) => {
            window.removeAppLoading();
            if (error.status === 0) {
              vm.showToast({
                type: "error",
                message:
                  "Verifique sua conexão com a Internet ou a disponibilidade do servidor",
              });
              return;
            }

            let errorMessage = ""

            switch(error.data.message) {
              case "Invalid e-mail or password": 
                errorMessage = "Email ou senha inválidos, tente novamente"
                break;
              case "Password is not valid":
                errorMessage = "Senha inválida"
                break;
            }
            
            vm.showToast({
              type: "error",
              message: errorMessage,
            });
          });
      }, 1000);
    },

    socketListeners() {
      const vm = this;
      this.$socket.on("qrcode", (event) => {
        if (event.op === "auth") {
          window.showAppLoading();
          window.setAppLoadingText("Tentando realizar o login...");
          setTimeout(() => {
            vm.authenticateByQRCode({ qrcodeKey: vm.qrcodeKey })
              .then(() => {
                window.setAppLoadingText("Sucesso! Aguarde...");
                vm.$socket.close();
                vm.$socket.removeAllListeners();
                setTimeout(() => {
                  if (vm.isAuthenticated) {
                    vm.$router.replace("/");
                  }
                }, 1000);
              })
              .catch((error) => {
                window.removeAppLoading();
                if (error.status === 0) {
                  vm.showToast({
                    type: "error",
                    message:
                      "Verifique sua conexão com a Internet ou a disponibilidade do servidor",
                  });
                  return;
                }
                vm.showToast({
                  type: "error",
                  message: error.data.message,
                });
              });
          }, 1000);
        }
      });
    },
  },
  mounted() {
    this.$socket.removeAllListeners();
    this.$socket.close();
    setTimeout(() => {
      if (window.isAppLoading()) {
        setTimeout(() => {
          window.removeAppLoading();
        }, 1000);
      }
      this.qrcodeKey = `${shortid.generate()}${shortid.generate()}`.toUpperCase();
      QRCode.toCanvas(
        document.getElementById("qrcode"),
        this.qrcodeKey,
        {
          maskPattern: 6,
          errorCorrectionLevel: "H",
          width: 300,
          margin: 0,
          scale: 1,
          color: {
            dark: "#ffffffff",
            light: "#000000ff",
          },
        },
        (error) => {
          if (error) {
            console.log(error);
            this.errorOnLoadQRCode = true;
          }
        }
      );

      this.$socket.io.opts.query = {
        qrcodeKey: this.qrcodeKey,
      };
      this.$socket.open();
      this.socketListeners();
    }, 500);
  },
};
</script>

<style scoped>
#page-login {
  background: transparent url("../../assets/imgs/bg-login.jpg") no-repeat center;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  align-items: center;
}

/* Login Page */
#page-login input {
  text-transform: uppercase;
  font-size: 24px;
}

#page-login input[type="email"] {
  text-transform: lowercase;
}

#page-login div.login__container {
  background-size: cover;
  background-position: center;
  width: 540px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.4);
  background-color: rgba(15, 15, 15, 0.9);
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

#page-login div.login__container h3 {
  display: none;
  margin: 0;
  text-align: center;
  font-size: 30px;
  font-weight: 600;
}

#page-login div.login__container .container__header {
  background-image: url("../../assets/imgs/logo-white.png");
  background-size: cover;
  background-position: center;
  justify-content: center;
  align-items: center;
  width: 241px;
  height: 64px;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

#page-login div.login__container .container__header h3 {
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 1px 1px #222;
}

#page-login div.login__container .container__header .btn {
  margin: 10px 0;
}

#page-login div.login__container .container__header small {
  color: rgba(255, 255, 255, 0.7);
}

#page-login div.login__container .container__body {
  flex-shrink: 0;
  padding: 40px 30px 20px;
  color: #333;
  text-align: center;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

#page-login div.login__container .container__body form {
  margin-bottom: 20px;
}

#page-login div.login__container .container__body form > div {
  margin-bottom: 20px;
  text-align: left;
}

#page-login div.login__container .container__body form > div label {
  color: #fff;
  font-weight: 600;
}

#page-login div.login__container .container__body form input.input {
  margin-bottom: 5px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
}

input.input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(255, 255, 255, 0.5);
}

input.input::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(255, 255, 255, 0.5);
}
input.input:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(255, 255, 255, 0.5);
}
input.input:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(255, 255, 255, 0.5);
}

#page-login div.login__container .container__body .body__action-buttons {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

#page-login div.login__container .container__body .btn {
  margin: 0;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}

#page-login div.login__container .container__body a {
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
}

#page-login .input,
#page-login .textarea,
#page-login .btn {
  height: 40px;
}

#page-login .control small {
  margin-top: 5px;
  font-size: 10px;
  color: #666;
  display: inline-block;
  line-height: 100%;
}

.btn {
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.4);
  background-color: rgba(255, 255, 255, 0.7);
  color: var(--font-color--primary);
  font-weight: 600;
  text-transform: uppercase;
  font-size: 14px;
}

.email-password-enter-active {
  transition: all 0.3s ease;
}
.email-password-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.email-password-enter, .email-password-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
